export const setViewFromAgentId = agentId => {
    return {
        type: 'SET_VIEW_FROM_AGENT_ID',
        agentId: agentId,
    }
};

export const setViewAgentId = agentId => {
    return {
        type: 'SET_VIEW_AGENT_ID',
        agentId: agentId,
    }
};